var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.b(),style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('div',{style:(_vm.styleImgName)})])}
var staticRenderFns = []

export { render, staticRenderFns }